import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=0866d90c&"
import script from "./EmailConfirmation.vue?vue&type=script&lang=ts&"
export * from "./EmailConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports